import { useState, createContext } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  getFlyOrdersUserService,
  uploadUserService,
} from "../../../services/userServices";
import {
  buyTicketCharter724AdminService,
  changeFlyOrderStatusAdminService,
} from "../../../services/adminServices";
import { validateFile } from "../../../utils";
import { uploadTypeItems } from "../../../utils/enum";

export const flyOrderUserContext = createContext({
  flyOrders: [],
  setFlyOrders: () => {},
  flyOrder: {},
  setFlyOrder: () => {},
  filter: "",
  setFilter: () => {},
  sort: "",
  setSort: () => {},
  start: "",
  setStart: () => {},
  end: "",
  setEnd: () => {},
  pageCount: null,
  setPageCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  itemsCount: null,
  setItemsCount: () => {},
  handleGetFlyOrders: () => {},
  handleChangeFlyOrderStatus: () => {},
  handleBuyTicket: () => {},
  handleUploadFile: () => {},
});

const FlyOrderUserContext = ({ children }) => {
  const dispatch = useDispatch();

  const { user } = useParams();

  const [flyOrders, setFlyOrders] = useState([]);
  const [flyOrder, setFlyOrder] = useState({});
  const [id, setId] = useState("");
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsCount, setItemsCount] = useState(100);

  // Get Fly Orders
  const handleGetFlyOrders = async (event) => {
    event?.preventDefault();

    const objData = {
      ...(start && { start }),
      ...(end && { end }),
      ...(user && { user }),
      filter,
      pageNumber,
      sort,
      itemsCount,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getFlyOrdersUserService(objData);
      if (status === 200) {
        setFlyOrders(data.result?.flyOrders);
        setPageCount(data?.result?.allPagesCount);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Change Fly Order Status
  const handleChangeFlyOrderStatus = async (userData) => {
    const objData = { ...userData, id: flyOrder._id };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await changeFlyOrderStatusAdminService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        setFlyOrder({});
        handleGetFlyOrders();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Buy Ticket
  const handleBuyTicket = async (id_request, id_faktor) => {
    const objData = { id_request, id_faktor };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await buyTicketCharter724AdminService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        setFlyOrder({});
        handleGetFlyOrders();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Upload File
  const handleUploadFile = async (file, callback) => {
    const fileErrorMessage = validateFile(file);
    if (fileErrorMessage) return toastErrorMessage(fileErrorMessage);

    const objData = { file };
    const params = { destination: uploadTypeItems[2] };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await uploadUserService(objData, params);
      if (status === 200) {
        callback && callback(data.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <flyOrderUserContext.Provider
      value={{
        flyOrders,
        setFlyOrders,
        flyOrder,
        setFlyOrder,
        id,
        setId,
        filter,
        setFilter,
        sort,
        setSort,
        start,
        setStart,
        end,
        setEnd,
        pageCount,
        setPageCount,
        pageNumber,
        setPageNumber,
        itemsCount,
        setItemsCount,
        handleGetFlyOrders,
        handleChangeFlyOrderStatus,
        handleBuyTicket,
        handleUploadFile,
      }}
    >
      {children}
    </flyOrderUserContext.Provider>
  );
};

export default FlyOrderUserContext;
